'use client';

import type { ListHometownNewsDto } from '@generated/unauth';
import useEmblaCarousel from 'embla-carousel-react';

import { RecommendHometownNewsVerticalCard } from './RecommendHometownNewsVerticalCard';

interface RecommendHometownNewsProps {
  id?: string;
  list: ListHometownNewsDto[];
}

export const RecommendHometownNews = ({
  id,
  list,
}: RecommendHometownNewsProps) => {
  const [emblaRef] = useEmblaCarousel({
    align: 'start',
    dragFree: true,
    containScroll: 'trimSnaps',
  });

  if (list.length < 1) return null;

  return (
    <article className="flex flex-col border-t-[6px] border-Gray-200 bg-Gray-white pb-30">
      <h4
        className="pb-16 pl-20 pt-32 font-700 text-Gray-900 typo-body1"
        id={id}
      >
        이런 이야기는 어때요?
      </h4>
      {list.length > 0 ? (
        <div className="m-0 mb-20 overflow-hidden pl-20" ref={emblaRef}>
          <div className="flex gap-12">
            {list.map((news) => (
              <div
                key={news.hometownNewsId}
                className="w-fit flex-[0_0_auto] last:mr-20"
              >
                <RecommendHometownNewsVerticalCard
                  key={news.hometownNewsId}
                  className="select-none"
                  idIdx={news.hometownNewsIdIdx}
                  name={news.hometownNewsName}
                  publishedAt={news.publishedAt}
                  thumbnail={news.thumbnail}
                />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </article>
  );
};
